<div class="bg-image">
    <app-header></app-header>
    <app-breadcrumb></app-breadcrumb>
    <div class="payment-block">
        <div class="payment-popup" id="bbox-root"></div>
    </div>
    <app-footer></app-footer>
</div>